import React, { useState, useEffect } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, FormControl, FormLabel, Input, Text, useColorModeValue, } from '@chakra-ui/react'

const PasswordPromptModal = ({ opened, onSubmit, onCancel, accountLabel }) => {
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (!opened) setPassword('')
  }, [opened])

  const handleSubmit = () => {
    onSubmit(password)
    setPassword('')
  }
  const handleCancel = () => {
    onCancel()
    setPassword('')
  }

  const bg = useColorModeValue('white', 'gray.800')

  return (
    < Modal isOpen={opened} onClose={handleCancel} isCentered motionPreset="scale" >
      < ModalOverlay bg="rgba(0, 0, 0, 0.55)" backdropFilter="blur(3px)" />
      <ModalContent bg={bg} maxW="400px" borderRadius="lg" boxShadow="lg" p={0} >
        <ModalHeader fontSize="lg" fontWeight="semibold" borderBottom="1px solid" borderColor="gray.200" px={6} py={4} >
          Link Your Account
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px={6} py={4}>
          <Text mb={4} fontSize="md">
          Please enter the password for your GRID account <b>{accountLabel || 'your account'}</b> to enable social login:
          </Text>
          <FormControl>
            <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </FormControl>
        </ModalBody>
        <ModalFooter borderTop="1px solid" borderColor="gray.200" px={6} py={4} >
          <Button variant="outline" mr={3} onClick={handleCancel}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit}>
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default PasswordPromptModal